package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.CombatRepository

/**
 * Arrête le combat : il devient inactif et disparaît chez tous les participants.
 */
class StopCombatUseCase(
    private val combatRepository: CombatRepository
) {
    suspend operator fun invoke(combatId: String): Result<Unit> =
        combatRepository.stopCombat(combatId)
}
